import { Injectable } from '@angular/core';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { HttpService } from './http.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  constructor(private httpService: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
      })
    );
  }
}
